import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box sx={{ 
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 30%, #2a2a2a 70%, #1a1a1a 100%)',
      py: 6,
      color: 'white'
    }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ 
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 'bold'
            }}>
              About YoungPresso
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.8)' }}>
              Kids News Magazine - Weekly Magazine for Kids of age 5+. News filtered and reworded to make it fit for Kids reading. Fully Digital Premium Magazine.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ 
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 'bold'
            }}>
              Quick Links
            </Typography>
            <Typography>
              <Link to="/about" style={{ color: 'rgba(255,255,255,0.8)', display: 'block', textDecoration: 'none', marginBottom: '8px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#FF6B35'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}>About Us</Link>
              <Link to="/contact" style={{ color: 'rgba(255,255,255,0.8)', display: 'block', textDecoration: 'none', marginBottom: '8px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#FF6B35'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}>Contact</Link>
              <Link to="/terms-and-conditions" style={{ color: 'rgba(255,255,255,0.8)', display: 'block', textDecoration: 'none', marginBottom: '8px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#FF6B35'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}>Terms & Conditions</Link>
              <Link to="/privacy-policy" style={{ color: 'rgba(255,255,255,0.8)', display: 'block', textDecoration: 'none', marginBottom: '8px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#FF6B35'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}>Privacy Policy</Link>
              <Link to="/cancellation-refund-policy" style={{ color: 'rgba(255,255,255,0.8)', display: 'block', textDecoration: 'none', marginBottom: '8px', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#FF6B35'} onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}>Cancellation & Refund Policy</Link>
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ 
              background: 'linear-gradient(45deg, #FF6B35 30%, #FFB74D 70%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 'bold'
            }}>
              Contact Us
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.8)' }}>
              Email: info@youngpresso.com<br />
              WhatsApp: +91 9958540416
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
